import React, { Fragment } from 'react'
import styled from 'styled-components'

import SectionHeader from '@/mdx/api/endpoints/section-header.mdx'
import Search from '@/mdx/api/endpoints/search.mdx'
import Trending from '@/mdx/api/endpoints/trending.mdx'
import Translate from '@/mdx/api/endpoints/translate.mdx'
import Random from '@/mdx/api/endpoints/random.mdx'
import ActionRegister from '@/mdx/api/endpoints/action-register.mdx'
import RandomId from '@/mdx/api/endpoints/random-id.mdx'
import GetGifById from '@/mdx/api/endpoints/get-gif-by-id.mdx'
import GetGifsById from '@/mdx/api/endpoints/get-gifs-by-id.mdx'
import Upload from '@/mdx/api/endpoints/upload.mdx'
import Categories from '@/mdx/api/endpoints/categories.mdx'
import Autocomplete from '@/mdx/api/endpoints/autocomplete.mdx'
import SearchSuggestions from '@/mdx/api/endpoints/search-suggestions.mdx'
import TrendingSearchTerms from '@/mdx/api/endpoints/trending-search-terms.mdx'
import ChannelsSearch from '@/mdx/api/endpoints/channel-search.mdx'
import { DocsPageGlobalStyle } from '@/styles'

import DividerLine from '../shared/divider-line'
import ApiSectionWrapper from '../shared/api-section-wrapper'
import Anchor from '../anchor'

const EndpointsContainer = styled.div``

type EndpointProps = {
  anchorId: string
}

const Endpoint: React.FC<EndpointProps> = ({ children, anchorId }) => {
  return (
    <ApiSectionWrapper>
      <DividerLine />
      <Anchor pathname="/docs/api/endpoint" id={anchorId} />
      {children}
    </ApiSectionWrapper>
  )
}

const EndpointsPage = () => {
  return (
    <Fragment>
      <EndpointsContainer>
        <DocsPageGlobalStyle />
        <SectionHeader />
        <Endpoint anchorId="trending">
          <Trending />
        </Endpoint>
        <Endpoint anchorId="search">
          <Search />
        </Endpoint>
        <Endpoint anchorId="translate">
          <Translate />
        </Endpoint>
        <Endpoint anchorId="random">
          <Random />
        </Endpoint>
        <Endpoint anchorId="action-register">
          <ActionRegister />
        </Endpoint>
        <Endpoint anchorId="random-id">
          <RandomId />
        </Endpoint>
        <Endpoint anchorId="get-gif-by-id">
          <GetGifById />
        </Endpoint>
        <Endpoint anchorId="get-gifs-by-id">
          <GetGifsById />
        </Endpoint>
        <Endpoint anchorId="upload">
          <Upload />
        </Endpoint>
        <Endpoint anchorId="categories">
          <Categories />
        </Endpoint>
        <Endpoint anchorId="autocomplete">
          <Autocomplete />
        </Endpoint>
        <Endpoint anchorId="channel-search">
          <ChannelsSearch />
        </Endpoint>
        <Endpoint anchorId="search-suggestions">
          <SearchSuggestions />
        </Endpoint>
        <Endpoint anchorId="trending-search-terms">
          <TrendingSearchTerms />
        </Endpoint>
      </EndpointsContainer>
    </Fragment>
  )
}

export default EndpointsPage
